import { getFilterValuesRest } from '@pages/Clients/ClientsList/utils';

import type { NClientsList } from '@pages/Clients/ClientsList/ClientsList.types';

export const clearPeriod: NClientsList.ClearPeriod = ({
  filters,
  serverFilters,
  filtersArea,
  filterGroupIndex,
  setFilters,
  setServerFilters,
}) => {
  const updateFilters: NClientsList.UpdateFilters = (type, oldFilters) => {
    const filterValuesRest = getFilterValuesRest({
      type,
      filtersArea,
      filterGroupIndex,
      filters,
      serverFilters,
    });

    return {
      ...oldFilters,
      [filtersArea]: Object.values({
        ...oldFilters[filtersArea],
        [filterGroupIndex]: {
          ...oldFilters[filtersArea][filterGroupIndex],
          Values: [
            {
              ...filterValuesRest,
              DateStart: null,
              DateEnd: null,
            },
          ],
        },
      }),
    };
  };

  setFilters(updateFilters('filters', filters));
  setServerFilters(updateFilters('serverFilters', serverFilters));
};
